import React, { useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { IconDownArrow } from '../icons/Icons';
const GalleryCarousel = ({ media }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
    });
    // Optional: Reset scroll position when media changes
    useEffect(() => {
        emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(0);
    }, [media, emblaApi]);
    // Prev button handler
    const scrollPrev = useCallback(() => {
        emblaApi && emblaApi.scrollPrev();
    }, [emblaApi]);
    // Next button handler
    const scrollNext = useCallback(() => {
        emblaApi && emblaApi.scrollNext();
    }, [emblaApi]);
    return (React.createElement("div", { className: "media-gallery embla", style: { position: 'relative' } },
        React.createElement("button", { className: "embla__button embla__button--prev", type: "button", onClick: scrollPrev, "aria-label": "Previous" },
            React.createElement(IconDownArrow, null)),
        React.createElement("button", { className: "embla__button embla__button--next", type: "button", onClick: scrollNext, "aria-label": "Next" },
            React.createElement(IconDownArrow, null)),
        React.createElement("div", { className: "embla__viewport", ref: emblaRef },
            React.createElement("div", { className: "embla__container" }, media.map((item, index) => (React.createElement("div", { className: "embla__slide", key: index }, item.media_type === 'image' && (React.createElement("img", { src: `https:${item.src}`, alt: `Media ${index}`, className: "embla__image" })))))))));
};
export default GalleryCarousel;
